import BaseComponent from '../abstracts/BaseComponent';

const debug = false;

export default class LoginTriggerComponent extends BaseComponent {

  constructor(element) {
    super(element);

    debug && console.log('LoginTriggerComponent');

    this.$el.addEventListener('click', this.click);
  }

  click = event => {
    debug && console.log('LoginTriggerComponent click', event);
    sessionStorage.setItem('loggedInHref', location.href);
    this.$options.target && sessionStorage.setItem('loggedInTarget', this.$options.target);
  }
}
